import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { AnimatePresence as AnimatePresence$1 } from 'framer-motion';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { Box, fillContainer, Portal } from '@costar/theme-ui';
import { getToastListStyle } from './toast.utils.esm.js';
import { Toast } from './toast.esm.js';
import React, { useMemo } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var AnimatePresence = AnimatePresence$1;
var toastContainerSx = {
  pointerEvents: 'none'
};

/**
 * Manages the creation, and removal of toasts
 * Creates a ul element for each position of the toast ("top", "bottom", etc.)...
 * so the 'toast' elements can portal onto.
 * Should be placed somewhere in the parent of application.
 */
var LocalToastHostContainer = function LocalToastHostContainer(props) {
  var _props$component = props.component,
    Component = _props$component === void 0 ? Toast : _props$component,
    toastStore = props.toastStore,
    offset = props.offset,
    container = props.container;
  var state = useSyncExternalStore(toastStore.subscribe, toastStore.getState, toastStore.getState);
  var stateKeys = Object.keys(state);
  var toastElements = stateKeys.map(function (position) {
    var toasts = state[position];
    return /*#__PURE__*/React.createElement(Box, {
      as: "ul",
      key: position,
      id: "csg-tui-toast-manager-".concat(position),
      style: getToastListStyle(position, {
        relative: true,
        offset: offset
      })
    }, /*#__PURE__*/React.createElement(AnimatePresence, {
      initial: false
    }, toasts.map(function (toast) {
      return /*#__PURE__*/React.createElement(Component, _extends({
        key: toast.id
      }, toast));
    })));
  });
  var boxOfToasts = useMemo(function () {
    return /*#__PURE__*/React.createElement(Box, _extends({
      className: 'csg-tui-local-toaster-container'
    }, fillContainer, {
      sx: toastContainerSx
    }), toastElements);
  }, [toastElements]);
  return /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, boxOfToasts);
};

export { LocalToastHostContainer };
//# sourceMappingURL=local-toast-host-container.esm.js.map
